import { Trans } from "@lingui/react/macro";
import { useState } from "react";

import { Button } from "../../../components/ui-kit/button";
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "../../../components/ui-kit/dialog";
import { CountriesRegionsPicker } from "./countries-regions-picker";
import { Location } from "./utils";

/**
 * Countries and regions of one access policy. Selections are held locally and
 * reach the caller's draft on Save, so closing discards them - the same
 * contract as the other scope pickers (patients, clinics, physicians), which
 * commit on confirm. The hosting dialog's own Save / Cancel still decides
 * whether the draft is written to the policy.
 */
export function LocationsDialog(props: {
  username: string;
  locations: Location[];
  onChange: (locations: Location[]) => void;
  onClose: () => void;
}) {
  const [locations, setLocations] = useState(props.locations);

  return (
    <Dialog open onOpenChange={(open) => !open && props.onClose()}>
      <DialogHeader>
        <Trans>Edit locations for: {props.username}</Trans>
      </DialogHeader>

      <DialogBody className="flex flex-col items-start">
        <CountriesRegionsPicker locations={locations} onChange={setLocations} />
      </DialogBody>

      <DialogFooter>
        <Button onClick={props.onClose}>
          <Trans>Cancel</Trans>
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            props.onChange(locations);
            props.onClose();
          }}
        >
          <Trans>Save</Trans>
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
